import { AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartOptions, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { BehaviorSubject } from 'rxjs';
import { themeStyling, themeStylingPAGraphColors } from 'src/themes/common/principal-theme';

@Component({
  selector: 'app-spider-chart',
  templateUrl: './spider-chart.component.html',
  styleUrls: ['./spider-chart.component.scss'],
  standalone: false,
})
export class SpiderChartComponent implements AfterViewInit, OnChanges {
  @Input() public data: any[] | undefined;

  @Input() public canvasName: string | undefined;

  @Input() public isCirc: boolean = false;

  @Input() public showDim: boolean = false;

  public color: string | undefined;

  public myChart: Chart | any;

  public chart: BehaviorSubject<Chart | undefined> = new BehaviorSubject<Chart | undefined>(undefined);

  public labels: string[] | undefined;

  public topData: number[] | undefined;

  public bottomData: number[] | undefined;

  public maxLvl: number = 0;

  constructor() {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);
  }

  setLabels() {
    const labels = [];
    for (const item of this.data!) {
      if (item.specialty.name !== 'Bariatrique' && item.specialty.name !== 'Anesthésie-réanimation') {
        if (this.showDim) {
          if (item.specialty.diminutif) {
            labels.push(item.specialty.diminutif);
          } else {
            labels.push(
              item.specialty.name.length > 5 ? item.specialty.name.substring(0, 5) + '.' : item.specialty.name
            );
          }
        } else {
          // let labelName = item.specialty.name.length > 15 && item.specialty.diminutif ? item.specialty.diminutif : item.specialty.name
          labels.push(this.showDim && item.specialty.diminutif ? item.specialty.diminutif : item.specialty.name);
        }
      }
    }
    this.labels = labels;
  }

  setTopData() {
    const topData = [];
    for (const item of this.data!) {
      if (item.specialty.name !== 'Bariatrique' && item.specialty.name !== 'Anesthésie-réanimation') {
        topData.push(item.maxLevel);
      }
    }
    this.topData = topData;
  }

  setBottomData() {
    const bottomData = [];
    for (const item of this.data!) {
      if (item.specialty.name !== 'Bariatrique' && item.specialty.name !== 'Anesthésie-réanimation') {
        bottomData.push(item.level);
      }
    }
    this.bottomData = bottomData;
  }

  getMaxLvl() {
    this.data?.forEach((specialty: any) => {
      if (specialty.maxLevel > this.maxLvl) {
        this.maxLvl = specialty.maxLevel;
      }
    });
  }

  filterData() {
    let count = 0;
    for (const item of this.data!) {
      if (item.level > 0) {
        count = count + 1;
      }
    }
    if (count > 5) {
      this.data = this.data?.filter((item: any) => item.level > 0);
    } else {
      this.data?.sort((a: any, b: any) => b.level - a.level);
    }
  }

  ngAfterViewInit() {
    this.color = themeStylingPAGraphColors.radar_graph_body_color;
    this.filterData();
    this.setLabels();
    this.setTopData();
    this.setBottomData();
    this.getMaxLvl();

    const config: ChartOptions = {
      // onHover: (context) => {
      //   context.chart.update();
      // },
      elements: {
        point: {
          radius: 3,
          borderColor: themeStylingPAGraphColors.radar_graph_border_color,
          hoverBackgroundColor: themeStylingPAGraphColors.radar_graph_hover_color,
        },
      },
      plugins: {
        datalabels: {
          formatter() {
            return '';
          },
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
      scales: {
        r: {
          pointLabels: {
            font: {
              family: themeStyling.fontFamilyPrimary,
              weight: 500,
              size: 12,
            },
            color: themeStylingPAGraphColors.radar_graph_labels_font_color,
            callback(arg: any): any {
              const listOfWords: string[] = arg.split(' ');
              if (listOfWords.length <= 2) {
                return arg;
              }
              return `${listOfWords.slice(0, 2).join(' ')} ${listOfWords[2].substring(0, 3)}.`;
            },
          },
          ticks: {
            font: {
              family: themeStyling.fontFamilyPrimary,
              weight: 600,
              size: 12,
            },
            stepSize: 1,
            color: themeStylingPAGraphColors.radar_graph_labels_font_color,
          },
          suggestedMin: 0,
          suggestedMax: this.maxLvl,
          angleLines: {
            display: false,
          },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    };

    this.myChart = new Chart(this.canvasName!, {
      type: 'radar',
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.bottomData,
            backgroundColor: this.color,
            borderColor: themeStylingPAGraphColors.radar_graph_border_color,
            borderWidth: 2,
            pointBackgroundColor: '#fff',
          },
        ],
      },
      options: config,
    });

    this.chart.next(this.myChart);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['data'] && changes['data'].previousValue) {
      this.filterData();
      this.setLabels();
      this.setTopData();
      this.setBottomData();
      this.getMaxLvl();

      this.myChart!.data.labels = this.labels;
      this.myChart!.data.datasets[0].data = this.bottomData!;
      this.myChart!.update();
    }
  }
}
